module.exports = __webpack_public_path__ + "static/customer-engagement-ab15ccb9d1d23b14305330c225ed8414.svg";